import { Box, Card, Chip, Typography } from '@mui/material';
import { useContext } from 'react';
import { formatMessage } from '../../utils/strings';
import { CURRENCY_SYMBOLS, PRICE_FROM_$ } from '../../constants/strings';
import PricesContext from './PricesContext';

const ServiceOptions = ({ options }) => {
  const { prices } = useContext(PricesContext);

  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: { xs: 'wrap', sm: 'nowrap' },
        justifyContent: 'space-evenly',
        px: { lg: 5 },
        maxWidth: '1500px',
        mx: 'auto',
      }}
    >
      {options.map((option, index) => (
        <Card
          key={index}
          sx={{
            mr: { sm: index < options.length - 1 ? 2 : 0 },
            width: { xs: '100%', sm: '33%' },
            border: '1px solid #CAC4BE',
            borderRadius: '4px',
            position: 'relative',
            overflow: 'visible',
            my: 1,
          }}
        >
          <Chip
            label={option.type}
            color='primary'
            sx={{
              position: 'absolute',
              left: '16px',
              top: '-9px',
              borderRadius: '4px',
            }}
            size='small'
          />
          <Box
            sx={{
              pb: 1,
              px: 2,
              pt: 2,
              height: '100%',
            }}
          >
            <Typography sx={{ mb: 0.5 }} fontSize={'1.25rem'}>
              {option.title}
            </Typography>
            <Chip
              label={option.deliveryDuration}
              size='small'
              sx={{ borderRadius: '4px', mb: 0.5, width: 'fit-content' }}
            />
            <Typography variant='body2' sx={{ mb: 0.5 }}>
              {option.description}
            </Typography>
            {prices?.[option.serviceType]?.baseRate && (
              <Typography
                variant='body1'
                sx={{ textAlign: 'right', mt: 'auto' }}
                color='text.secondary'
              >
                {formatMessage(
                  PRICE_FROM_$,
                  CURRENCY_SYMBOLS.GBP,
                  prices[option.serviceType].baseRate
                )}
              </Typography>
            )}
          </Box>
        </Card>
      ))}
    </Box>
  );
};

export default ServiceOptions;
